//EX 19-09-2026 - MAPA UNICO DEL FORMULARIO DE EXPEDIENTE
//
//Este archivo reemplaza a los dos mapas que habia antes (map_expedientes.js para el alta y
//map_expedientesEdit.js para la edicion), que eran dos implementaciones del mismo mapa. Se tomo como
//base el del alta (el completo) y se le incorporo lo bueno de la edicion. La edicion GANA con esto:
//capa WMS de ARBA, eventos de borrado DELETESTOP/DELETED, handler layeradd, y markers clicables.
//Validado en las dos pantallas antes de reemplazar.
//
//Base: el mapa del alta (es el completo) + lo bueno de la edicion:
//  - partidoQuery robusto: convierte con toString() y contempla null. El alta asumia string, y con un
//    partido numerico .length es undefined -> partidoQuery quedaba sin el cero de relleno (71 en vez
//    de 071) y la consulta al WMS devolvia OTRO poligono.
//  - vacioG: constante con la geometria vacia canonica, que el alta escribia a mano con dos valores
//    distintos (uno de ellos 'features:[]', que no es el valor real).
//  - la condicion del filtro incluye || seccQuery === ''.
//Gana la edicion: capa WMS de ARBA, eventos de borrado DELETESTOP/DELETED, handler layeradd, y
//markers clickable:true.
//
//FIX respecto de la primera version unificada: el efecto de [addLAYER] NO lleva la comprobacion de
//geometria vacia (ver la nota en el propio efecto: textGEOM es una foto del montaje, asi que esa
//condicion lo desactivaba para siempre en un alta nueva y rompia el dibujado y el zoom).
//
import React, { useRef, useState, useEffect, useContext } from 'react';
import { SessionContext } from '../context/sessionContext';
import { toast } from "react-toastify";
import L from 'leaflet';
import Draw from 'leaflet-draw';
//import { Map, TileLayer, FeatureGroup } from "react-leaflet";
//import { EditControl } from "react-leaflet-draw";
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';


const style = {
    width: "100%",
    height: "100%"
};

const eventHandlers = {    
    onDrawStart: 'draw:drawstart',
    onDrawStop: 'draw:drawstop',    
};

//const BING_KEY = 'AtfyQFLwAqMac5Le45E3ZNuHoolIPOnbS5lneKbIaWJI60e9cBfcvxZeBKjU-tH2';

const sin_base = L.tileLayer('http://sin_base.com/{z}/{x}/{y}',{
    maxZoom: 20
});

const argenMap = L.tileLayer('https://wms.ign.gob.ar/geoserver/gwc/service/tms/1.0.0/capabaseargenmap@EPSG%3A3857@png/{z}/{x}/{-y}.png', {
    attribution: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | <a href="http://www.ign.gob.ar/AreaServicios/Argenmap/IntroduccionV2" target="_blank">Instituto Geográfico Nacional</a> + <a href="http://www.osm.org/copyright" target="_blank">OpenStreetMap</a>',
    minZoom: 3,
    maxZoom: 20
});

//EX 19-09-2026: ARREGLO DE LA CAPA BASE. Antes era "http://{s}.tile.osm.org/{z}/{x}/{y}.png", con dos
//problemas que se suman y explicaban el sintoma "se ve la mitad de los tiles":
//  1) HTTP en una pagina HTTPS: el navegador bloquea el pedido como contenido mixto (o lo manda a
//     HTTPS por HSTS). El usuario veia pedidos con "307 Internal Redirect" que no respondian.
//  2) Los subdominios a/b/c de tile.osm.org ya no se usan: OSM atiende en tile.openstreetmap.org.
//Resultado: los tiles que estaban en cache se veian y los nuevos no -> media capa pintada. Al dibujar
//(o al hacer zoom) el mapa pide tiles nuevos, que no estan en cache: por eso ademas la capa base
//"desaparecia" al completar el poligono.
//El bug es PREEXISTENTE (tambien en el mapa original y en produccion).
const osm = L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 20
});

//EX 16-10-2026: se saca la capa base "Carto" (CartoDB_DarkMatter) porque el servicio ahora
//pide una API Key y no carga. Reportado por el usuario.

const gMapsSat = L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    {
      minZoom: 2,
      maxZoom: 20,
      id: "google.satellite"
    }
);

//https://carto.arba.gov.ar/cartoArba/ProxyMap?LAYERS=carto%3AMacizos%2Ccarto%3AParcelas%20Rurales%2Ccarto%3AParcelas%2Ccarto%3ASubparcelas%2Ccarto%3AEquipamiento_Comunitario%2Ccarto%3AEspacio%20Verde%2Ccarto%3ACotas%2Ccarto%3ACotas_sp%2Ccarto%3ASeccion%2Ccarto%3ACircunscripcion%2Ccarto%3APartidos%2Ccarto%3ACalles%2Ccarto%3ALimites%2Ccarto%3ACuerpos_de_agua%2Ccarto%3ARed_Ferroviaria%2Ccarto%3Aign_cursos_de_agua&TRANSPARENT=TRUE&FORMAT=image%2Fpng8&BUFFER=0&STYLES=Carto_Macizos_label%2CCarto_Parcelas_Rurales_label%2CCarto_Parcelas_label%2CCarto_Subparcelas_label%2CCarto_Parcelas_label%2Ccarto%3ACarto_Espacio_Verde_label%2CCotas%2CCarto_Cotas_Subparcelas%2CCarto_Seccion_label%2CCarto_Circunscripcion_label%2CPartidos_label%2CCarto_Calles_label%2CLimite_label%2Cempty%2Cempty%2Cempty&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&SRS=EPSG%3A900913&BBOX=-6717198.6013846,-4431845.8952876,-6711953.1103192,-4428141.0880734&WIDTH=1098&HEIGHT=775&tiled=true&gwc=false&namedgrouped=&namedgroupedtransparent=&maptransparent=false&viewparams=xmin%3A-6717198.6013846%3Bymin%3A-4431845.8952876%3Bxmax%3A-6711953.1103192%3Bymax%3A-4428141.0880734%3Bepsg%3A900913&intscale=13541&tilesorigin=-20037508.34%2C-20037508.34
const layer_ARBA = L.tileLayer.wms('https://carto.arba.gov.ar/cartoArba/ProxyMap?', {
    layers: 'carto:Partidos',
    transparent: true,
    format: 'image/png8',
    styles:['carto:Partidos','carto:empty'],
    request: 'GetMap',   
    crs: L.CRS.EPSG4326,    
    opacity: 1,
    tiled:true,
    gwc:true,
    namedgrouped:'carto:Carto_Grupo',
    namedgroupedtransparent: 'carto:Carto_Grupo_transparent',
    maptransparent:false,
    viewparams:'xmin:-63.67037287773794;ymin:-41.063632155155055;xmax:-56.46478067123993;ymax:-33.291679965530854;epsg:4326',
    intscale:1733371    
});
//viewparams:'minx=-63.67037287773794 miny=-41.063632155155055 maxx=-56.46478067123993 maxy=-33.291679965530854;epsg:4326'
//&intscale=6933486&tilesorigin=-20037508.34,-20037508.34'

//http://geo.arba.gov.ar/geoserver/idera/wms
//https://ide.transporte.gob.ar/geoserver/observ/wms
const layer_1101 = L.tileLayer.wms('https://geo.arba.gov.ar/geoserver/idera/wms?', {
    layers: 'idera:Grupo IDERA',
    STYLES: '',
    VERSION: '1.1.1',
    tiled: true,
    crs: L.CRS.EPSG4326,
    format: 'image/png',
    transparent: true,
    tilesorigin: [-180, 90],
    opacity: 1,
    maxZoom: 20
});

//http://181.171.117.68/geoserver/wms?SERVICE=WMS&request=getCapabilities
const layer_4101 = L.tileLayer.wms('http://181.171.117.68/geoserver/wms?', {
    layers: 'capabase',
    crs: L.CRS.EPSG4326,
    format: 'image/png',
    transparent: true,
    opacity: 1
});


//URBASIG http://urbasig.gob.gba.gob.ar/geoserver/urbasig/wms?
//EX 19-09-2026: pasa a HTTPS para quedar alineado con PRODUCCION, donde la edicion ya llama a
//urbasig por HTTPS. En una pagina HTTPS la version http:// se bloquea como contenido mixto.
const layer_2101 = L.tileLayer.wms('https://urbasig.gob.gba.gob.ar/geoserver/urbasig/wms?', {
    layers: 'urbasig:_zonificacion',
    crs: L.CRS.EPSG4326,
    format: 'image/png',
    transparent: true,
    opacity: 1
});

//EX 19-09-2026: idem layer_2101 (alineado con produccion).
const layer_3101 = L.tileLayer.wms('https://urbasig.gob.gba.gob.ar/geoserver/urbasig/wms?', {    
    layers: 'urbasig:areas_ley_8912',
    crs: L.CRS.EPSG4326,
    format: 'image/png',
    transparent: true,
    opacity: 1
});

const geojsonTemp = {
    fillColor: "green",
    color: "green",
    weight: 2,
    opacity: 1,
    fillOpacity: 0.8
};

const geojsonTempB = {
    fillColor: "green",
    color: "green",
    weight: 2,
    opacity: 0.8,
    fillOpacity: 0.05
};

const geojsonTempC = {
    fillColor: "yellow",
    color: "yellow",
    weight: 2,
    opacity: 0.8,
    fillOpacity: 0.05
};

//PRUEBA harcodeada, no se agrega al mapa, solo cuando se activa en el menu de capas

//EX 19-09-2026 (unificacion de los mapas): valor de geometria vacia. Es el que usa el contexto al
//arrancar y el que muestra el campo 'Datos catastrales - geojson' (admin) en un expediente recien
//creado. La edicion ya lo tenia como constante (vacioG) y este archivo lo escribia a mano, con DOS
//valores distintos: el efecto de la linea ~430 usaba este, y el de ~403 usaba 'features:[]', que no
//es el valor real, asi que esa rama nunca se ejecutaba.
const vacioG = `{"type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{}}]}`;

const datosTextHARD = `{"type":"FeatureCollection","totalFeatures":"unknown","features":[{"type":"Feature","id":"Seccion_Catastral.3768","geometry":{"type":"MultiPolygon","coordinates":[[[[-60.187174,-36.96339],[-60.206022,-36.94794],[-60.200912,-36.943938],[-60.22006,-36.928529],[-60.215907,-36.92524],[-60.212861,-36.922831],[-60.210131,-36.920702],[-60.205094,-36.916803],[-60.203863,-36.915988],[-60.200009,-36.912984],[-60.200006,-36.912829],[-60.198862,-36.911979],[-60.190229,-36.904857],[-60.190105,-36.904842],[-60.188028,-36.903178],[-60.186682,-36.902086],[-60.185172,-36.900899],[-60.182158,-36.898533],[-60.175127,-36.89292],[-60.153422,-36.87569],[-60.115379,-36.845489],[-60.108292,-36.85135],[-60.096263,-36.860665],[-60.096104,-36.860536],[-60.086356,-36.8682],[-60.086555,-36.868389],[-60.093916,-36.874178],[-60.095521,-36.875435],[-60.098041,-36.877389],[-60.100562,-36.879285],[-60.105981,-36.883463],[-60.107303,-36.884472],[-60.104151,-36.887046],[-60.129042,-36.906794],[-60.133994,-36.910668],[-60.138987,-36.91462],[-60.132749,-36.919712],[-60.137726,-36.923663],[-60.156514,-36.908467],[-60.161513,-36.912458],[-60.164268,-36.910164],[-60.179125,-36.92182],[-60.184126,-36.925742],[-60.181076,-36.928267],[-60.186148,-36.932189],[-60.17978,-36.937384],[-60.169836,-36.929487],[-60.16378,-36.934441],[-60.163113,-36.935149],[-60.158115,-36.939056],[-60.158032,-36.939251],[-60.159161,-36.940075],[-60.160324,-36.941019],[-60.162848,-36.943068],[-60.162135,-36.943669],[-60.187174,-36.96339]]]]},"geometry_name":"geom","properties":{"cca":"078020K","ara3":49977.69,"sag":"ARBA"}}],"crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:EPSG::4326"}}}`;
const datosHARD = JSON.parse(datosTextHARD);
/*
EX 19-09-2026 (unificacion de los mapas): requiredHARD quedo COMENTADO, como estaba en el alta.
En la edicion existia como L.geoJson(null) agregado al mapa, pero nada le carga datos (todas las
referencias estan comentadas), asi que era un no-op: no aporta nada y ademas obligaba a definir una
variable que el alta no usa. Queda anotado como codigo muerto para limpiar.
let requiredHARD=L.geoJson(null, {style: geojsonTemp});
*/
//let requiredHARD=L.geoJson({ "type": "FeatureCollection", "features": [ { "type": "Feature", "properties": {}, "geometry": { "coordinates": [ [ [ -62.28381380389676, -38.7242032562095 ], [ -62.28168891928466, -38.72530064031854 ], [ -62.2797136744346, -38.72406316340791 ], [ -62.28076115276396, -38.722452076448405 ], [ -62.28381380389676, -38.7242032562095 ] ] ], "type": "Polygon" } } ] }, {style: geojsonTemp});
//let requiredHARD=L.geoJson(null, {style: geojsonTemp});

//let tempLayer = L.geoJson(null, {style: geojsonTemp});

//EX 19-09-2026: estilo UNICO para los poligonos del area editable, para que se vean igual los que se
//dibujan y los que se cargan de la base. Reportado por el usuario: los poligonos nuevos salian con la
//transparencia por defecto de Leaflet Draw (fillOpacity 0.2), pero los existentes se agregaban con
//gardenStyle, que tiene fillOpacity 1, o sea opacos.
const ESTILO_POLIGONO = {
    color: 'dodgerblue',
    weight: 2,
    fillColor: 'dodgerblue',
    fillOpacity: 0.2,
};
function estiloPoligonoEditable() {
    return Object.assign({}, ESTILO_POLIGONO);
}

//gardenStyle queda sin usar (era el de los poligonos cargados). Se conserva por si se quiere volver al
//amarillo, que era la unica diferencia visible con los poligonos nuevos.
function gardenStyle(feature) {
    return {
        fillColor: "yellow",
        fillOpacity: 1,
        color: '#B04173',
    };
}

//let editableLayers = L.geoJson(null, {style: gardenStyle});

let geoJsonLayer = L.geoJson();


const Map_Expedientes =({partido, circ, secc, partidoGEO}) => {

    console.log("partidoGEO", partidoGEO);

    function geojsonTempPartido(feature) {
        return {
            fillColor: "green",
            fillOpacity: 0.25,
            color: 'green',
        };
    }

    //EX 19-09-2026: ESTE era el estilo de los poligonos que se cargan para editar (el efecto que dibuja la
    //geometria del expediente usa AAStyle). Tenia fillOpacity 1, o sea OPACO, y por eso los poligonos
    //existentes se veian sin transparencia mientras que los nuevos salian con la del control de dibujo.
    //Ahora devuelve el mismo estilo unificado, asi dibujar y editar se ven igual.
    function AAStyle(feature) {
        return Object.assign({}, ESTILO_POLIGONO);
    }

    const mapRef = useRef(null);
    console.log(secc);
    //const layerRef = useRef(null); //PARA layerGroup

    const geoJsonRef = useRef(null);
    const editableLayers = useRef(null);
    //console.log(editableLayers)

    const customParams = useRef(null);    
    const toolbar = useRef(null);    
    
    //const editableLayers= useRef(null);    

    //const layerGeoJson = L.geoJson(null, {style: geojsonTemp});

    //editableLayers=L.geoJson(null, {style: geojsonTemp});    
    
    //EX 19-09-2026: tambien cambioOriginal, para marcar el formulario como modificado cuando se toca la
    //geometria (ver savePolygon).
    const { geom, cambioGeom, cambioOriginal } = useContext(SessionContext);
    
    //----ESTADOS----
    const [textGEOM, setTextGEOM]=useState(JSON.stringify(geom));
    
    const [featuresFILTER, setCharacterFILTER] = useState(null);

    const [addLAYER, setAddLAYER]=useState([]);

    // ***add 7-agos-2023******* Manejar geojson de partido para mostrar en el mapa

    const [dataPartido, setDataPartido]=useState(null); 

    useEffect(()=>{ // ***add 7-agos-2023

        if(partidoGEO !== null ){
            setDataPartido(partidoGEO); //lo que recibe
        }

    }, [partidoGEO]);    

    useEffect(()=>{
        if(dataPartido !== null){           
            const partidoL=L.geoJson(dataPartido, {style: geojsonTempPartido}).addTo(mapRef.current);             

            //console.log("EDITABLE --->", addLAYER);

            if(addLAYER.length < 1){
                console.log("EDITABLE --->", addLAYER);
                mapRef.current.fitBounds(partidoL.getBounds());

            }
        }

    }, [dataPartido])

    //***cierra manejo capa partido */

    ///*FUNCIONA, POR AHORA NO USAR
    //const [newParcel, setNewParcel] = useState([]);

    //CASO 1: Ideal (que lleguen los 3 datos completos 114 01 0A)- armo la cadena y consulto contra url Secciones

    let partidoQuery = '000';
    //EX 19-09-2026: se deja EXACTAMENTE la expresion del mapa original, a proposito.
    //Al unificar la habia "mejorado" con partido.toString() para contemplar numeros, pero eso CAMBIA EL
    //COMPORTAMIENTO del alta: ahi partido arranca como NUMERO 0 (ver expediente.js: "estado inicial tiene
    //que ser un numero"), y con la version del original (0).length es undefined -> partidoQuery queda '0',
    //mientras que con toString() queda '000'. Distinta consulta al WMS = distinta capa (se veia el partido
    //a la mitad). Antes de cambiar esto hay que verificar el efecto en las dos pantallas.
    //(El bug latente sigue anotado: si a esta pantalla le llegara un partido numerico distinto de 0, la
    //consulta saldria sin el cero de relleno. Se corrige aparte, con prueba.)
    if(partido.length===1){
        partidoQuery = `00${partido}`;
    } else if(partido.length===2){
        partidoQuery = `0${partido}`;
    } else {
        partidoQuery = `${partido}`;
    }
    //console.log("PARTIDO QUERY--->", partidoQuery);

    let circQuery = '00';

    if(circ === null || circ === ''){
        circQuery= '00';
    } else if(circ.length===1){
        circQuery = `0${circ}`;
    } else {
        circQuery = `${circ}`;
    }
    console.log("QUERY CIRC--->", circQuery);

    let seccQuery = '00';
    if(secc === null || secc === ''){
        seccQuery = '00';
    } else if(secc.length===1){
        seccQuery = `0${secc}`;
    } else {
        seccQuery = `${secc}`;
    }
    console.log("QUERY SECC--->", seccQuery);

    let cadenaFilter;
    let typeName; //typeName=idera:Seccion_Catastral

    //let urlQuery;

    if(circQuery==='00'){
        cadenaFilter=`${partidoQuery}`;
        typeName=`typeName=idera:Departamento`;
        console.log("A");    

    } else if(circQuery!=='00' && seccQuery === '00' || seccQuery === ''){
        cadenaFilter=`${partidoQuery}${circQuery}`;
        typeName=`typeName=idera:Circunscripcion`;
        console.log("B"); 

    } else if(circQuery!=='00' && seccQuery !== '00'){
        cadenaFilter=`${partidoQuery}${circQuery}${seccQuery}`;
        typeName=`typeName=idera:Seccion_Catastral`;
        console.log("C"); 
    }
    console.log("CADENA QUERY---->", cadenaFilter);

    //CQL_FILTER=cca LIKE '078020K'
    let cqlFilter= `CQL_FILTER=cca LIKE '${cadenaFilter}'`;

    let cqlFilterPartido= `CQL_FILTER=cca LIKE '${partidoQuery}'`;

    const savePolygon= (geojsonDatos)=>{
        //console.log("RECIBE DATOS PARA GUARDAR---->", geojsonDatos)
        //setPolygonFINAL(geojsonDatos)
        //setGeom(geojsonDatos);      
       
        cambioGeom(geojsonDatos);

        //EX 19-09-2026: BUG REPORTADO - modificar los vertices no habilitaba el guardado.
        //Los botones de Guardar se deshabilitan cuando `original === 0`, y ese flag solo lo activaba el
        //onChange de los CAMPOS del formulario: dibujar, editar vertices o borrar un poligono cambiaba la
        //geometria pero no el flag, asi que el usuario tenia que tocar cualquier otro campo (por ejemplo
        //Cantidad de Lotes) para que se activaran. Ahora tocar la geometria tambien cuenta como cambio.
        cambioOriginal(1);
    } 
    
    //-------------EFECTOS--------

    useEffect(() => {   

        //EX 19-09-2026: contenedor PROPIO. Los mapas originales usan L.map('map') con un id fijo, y
        //react-bootstrap deja el modal montado despues de abrirlo una vez: al abrir este mapa habiendo
        //abierto antes el otro, en el DOM hay DOS elementos con id='map' y Leaflet se queda con el
        //PRIMERO, que puede ser el del modal oculto (tamano cero) -> los tiles no se dibujan y las capas
        //quedan a medio renderizar. Con un id propio no hay ambiguedad.
        mapRef.current = L.map('map_nuevo', {
            center: [-37.265645, -60.067551],
            zoom: 7,
            //EX 16-10-2026: la capa base se agrega ACA, al crear el mapa. Antes la agregaba un
            //useEffect sin array de dependencias que corria en CADA render (sacaba y volvia a poner
            //osm), y por eso la capa base elegida volvia a OSM sola despues de dibujar.
            layers: [osm],
        });

        //EX 19-09-2026: ARREGLO DEL RENDERIZADO DENTRO DEL MODAL.
        //Sintomas (preexistentes, tambien en produccion y en el mapa original): al primer zoom la capa del
        //partido se ve a la mitad, y al completar el dibujo del poligono la capa base (los tiles) deja de
        //verse.
        //Causa: Leaflet mide el contenedor cuando lo inicializa, pero el modal de Bootstrap todavia se
        //esta abriendo (usa una animacion con transform). El mapa queda calculado con un tamano que no es
        //el definitivo y dibuja los tiles y las capas con esa metrica: de ahi los parches a medio pintar.
        //invalidateSize() obliga a Leaflet a volver a medir y repintar. Se hace con un pequeño retardo
        //para que caiga despues de la animacion, y tambien si el contenedor cambia de tamano.
        const reajustarTamano = () => {
            if (mapRef.current) mapRef.current.invalidateSize();
        };
        const temporizador = setTimeout(reajustarTamano, 350);
        window.addEventListener('resize', reajustarTamano);

        //EX 19-09-2026: ARREGLO DE VERDAD (el temporizador de arriba no alcanzaba).
        //Sintoma: la capa del partido (un GeoJSON) se dibujaba solo en la MITAD SUPERIOR del mapa, y al
        //acercar el zoom la parte visible se hacia mas chica. La capa base de OSM, en cambio, se veia bien.
        //Por que esa diferencia: los tiles de OSM son imagenes posicionadas de forma absoluta, no dependen
        //del tamano interno del mapa; los vectores (GeoJSON) se dibujan como SVG y el SVG SI esta recortado
        //al viewport del mapa. Si Leaflet midio el contenedor a media altura (lo mide al inicializar, y el
        //modal de Bootstrap todavia se estaba animando), el SVG queda de media altura: el poligono solo se
        //dibuja arriba y, al hacer zoom, esa ventana fija ocupa cada vez menos.
        //Un temporizador no alcanza porque la medicion puede llegar tarde igual (de ahi que el sintoma
        //fuera intermitente). ResizeObserver avisa cada vez que el contenedor cambia de tamano de verdad.
        let observador = null;
        if (typeof ResizeObserver !== 'undefined' && mapRef.current) {
            observador = new ResizeObserver(reajustarTamano);
            observador.observe(mapRef.current.getContainer());
        }

        //EX 19-09-2026: LO QUE FALTABA (y por que el ResizeObserver no alcanzaba).
        //El modal de Bootstrap entra con una ANIMACION de transform (escala/traslacion). Cuando el mapa se
        //inicializa, ese transform esta aplicado, asi que el contenedor se MIDE MAS CHICO de lo que sera.
        //El problema: como es un transform y no un cambio de layout, el TAMANO REAL no cambia nunca, asi
        //que ResizeObserver no tiene nada que avisar y el mapa se queda con la medida chica. Consecuencia:
        //los vectores (SVG, recortado al viewport) se dibujan solo en una parte del mapa; el recorte queda
        //a una distancia FIJA en pixeles, por eso al hacer zoom abarca cada vez menos terreno y "la parte
        //visible se achica". Los tiles de la base no se ven afectados porque son imagenes posicionadas de
        //forma absoluta.
        //Solucion: remedir unas cuantas veces durante y despues de la animacion. No alcanza con un unico
        //temporizador (la animacion no dura siempre lo mismo) y el observer no ve transforms.

        //EX 19-09-2026: ACA ESTA LA CAUSA DEL RECORTE, medida en el navegador del usuario.
        //Con el poligono cortado, la consola mostro:
        //    sano:    contenedor 1564x898 | svg 1877x1078 | viewBox:  547  -31 1877 1078
        //    fallado: contenedor 1564x898 | svg 1877x1078 | viewBox: -156  -90 1877 1078
        //El TAMANO del svg es correcto en los dos casos; lo que cambia es el ORIGEN del viewBox: en el
        //estado fallado arranca casi en el origen, mientras el poligono se dibuja en coordenadas de
        //pixeles lejanas (el mapa se movio al partido). Todo lo que cae fuera de ese rectangulo se
        //recorta: ese es el corte, y por eso era intermitente (el viewBox se calcula antes de que el mapa
        //se vaya al partido y a veces no se vuelve a recalcular).
        //Arreglo: redraw() del renderizador RECALCULA el viewBox (es API publica de L.Renderer). Se llama
        //solo cuando detectamos que quedo desalineado, asi no se repinta de mas.
        const repararViewBoxSiHaceFalta = () => {
            const mapa = mapRef.current;
            if (!mapa) return;
            const cont = mapa.getContainer();
            const svg = cont && cont.querySelector('svg.leaflet-zoom-animated');
            if (!svg) return;

            const bounds = mapa.getPixelBounds();
            const padding = bounds.getSize().multiplyBy(0.1); //Leaflet usa 0.1 de padding
            const esperadoX = Math.round(bounds.min.x - padding.x);
            const esperadoY = Math.round(bounds.min.y - padding.y);
            const vb = (svg.getAttribute('viewBox') || '').split(/\s+/).map(Number);
            const desalineado = vb.length < 4 ||
                Math.abs(vb[0] - esperadoX) > 4 || Math.abs(vb[1] - esperadoY) > 4;

            if (desalineado) {
                console.warn('[mapa] viewBox del SVG desalineado -> lo corrijo', {
                    viewBox: vb.slice(0, 4), esperado: [esperadoX, esperadoY],
                    zoom: mapa.getZoom()
                });
                mapa.eachLayer(layer => {
                    if (layer instanceof L.Path || layer instanceof L.GeoJSON) {
                        if (typeof layer.redraw === 'function') layer.redraw();
                    }
                });
            }
        };

        //Remedir y reparar el viewBox unas cuantas veces al arrancar, mientras y despues de la animacion
        //del modal (que dura distinto segun el caso), y despues en cada zoom/movimiento.
        const remedidas = [150, 350, 600, 900, 1400].map(ms => setTimeout(() => { reajustarTamano(); repararViewBoxSiHaceFalta(); }, ms));
        mapRef.current.on('zoomend moveend', () => { reajustarTamano(); repararViewBoxSiHaceFalta(); });
        repararViewBoxSiHaceFalta();

        //getData();        
        return () => {
            clearTimeout(temporizador);
            window.removeEventListener('resize', reajustarTamano);
            if (observador) observador.disconnect();
            remedidas.forEach(clearTimeout);

            //EX 19-09-2026: DESTRUIR el mapa al desmontar el componente.
            //Sintoma que llevo a esto: despues de usar el modal del mapa, al cambiar de pestaña y volver
            //se veian "pedazos" de la pagina y zonas en blanco, y solo se arreglaba yendo a otra pestaña
            //y volviendo. Pasa solo con el modal de mapas.
            //Causa: react-bootstrap deja el contenido del modal montado al cerrarlo, asi que Leaflet
            //nunca se destruia: sus paneles (que usa con transform y el navegador promueve a capas de
            //composicion) quedaban en el DOM sosteniendo una superficie enorme, y el repintado de toda la
            //pagina salia mal. map.remove() desarma el mapa y saca esos paneles.
            //Para que esto se ejecute hay que desmontar el contenido del modal al cerrarlo: se le agrega
            //unmountOnExit al Modal (ver datosExp/datosEditExp).
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, []);
    

    //ULTIMO PASO: if featuresFILTER ya tiene datos (distinto de null), agregar a geoJsonRef y luego la capa al mapa
    //hacer zoom
    //para que no se vea el poligono, limpiar la capa
    useEffect(()=>{ 

        if(featuresFILTER !== null){
            //console.log("CAMBIO featuresFILTER---->2DO");

            let datos = featuresFILTER;
            let editable = editableLayers.current;

            geoJsonRef.current = L.geoJSON(datos, {style: geojsonTempB}).addTo(mapRef.current);
            //console.log("3RO...QUE TIENE?", geoJsonRef.current)
            //console.log("4TO----->", geoJsonRef.current.getBounds().isValid())

            if(editable.getBounds().isValid() === true){
                mapRef.current.fitBounds(editableLayers.current.getBounds());

            } else if(geoJsonRef.current.getBounds().isValid() === true){
                mapRef.current.fitBounds(geoJsonRef.current.getBounds());
            } else if(partido !== null && partido > 0){
                
                toast.success(`Haciendo zoom al partido ${partido}`);
                //getSoloPartido()                
                
            } else if(partido === null || partido === 0){
                toast.success("No se puedo obtener la capa");
            }
        }        

    }, [featuresFILTER]);

    /*useEffect(()=>{
        if(textGEOM !== vacioG){        
        //if(textGEOM !== vacioG){
            alert("ALERT 1 - nuevo")
            let datos = geomPoly;
            console.log("TIENE que agrrgar lo que viene en geomPoly", datos)
            //datos.addTo(layerRef.current)
            //layerRef.current = L.geoJSON(datos, {style: geojsonTemp}).addTo(mapRef.current);

            //console.log("HARDC", datosHARD );
            //console.log("DATOS", datos);

            //let temp1= L.geoJSON(datos, {style: geojsonTemp});

            //***************************************
            //NO FUNCIONA ---> pasandole datos
            //editableLayers.current.addLayer(datos, {style: geojsonTemp});

            //FUNCIONA ---> pero no aparece como editable
            //editableLayers.current = L.geoJSON(datos, {style: geojsonTemp}).addTo(mapRef.current);

            //***************************
            //console.log("3RO...QUE TIENE?", editableLayers.current)            
            
        } else{
            //editableLayers.current = L.geoJSON();
        }

    }, [geomPoly]) //solo cuando la geom de los poligonos*/

    useEffect(()=>{
        //EX 19-09-2026: aca NO va la comprobacion de geometria vacia. textGEOM se inicializa
        //con JSON.stringify(geom) y setTextGEOM NUNCA se llama: es una FOTO del valor del montaje.
        //En un alta nueva esa foto es justamente la geometria vacia, asi que una condicion del tipo
        //textGEOM !== vacioG quedaria falsa PARA SIEMPRE y este efecto no correria nunca: al dibujar,
        //el poligono no se agregaba a la capa editable ni se hacia el zoom (bug visto al probar).
        //La version original del alta comparaba contra '{"type":"FeatureCollection","features":[]}',
        //que no coincide con el valor real, asi que el efecto SIEMPRE corria: ese era el bueno.
        if(true){
            //console.log("QUE CARGUE!!!!", addLAYER);
            //alert("ALERT 2 - nuevo")

            if(addLAYER !== null){

                return addLAYER.map((feature, index) => {
                    
                    editableLayers.current.addLayer(feature, {style: estiloPoligonoEditable});
                    //console.log(editableLayers.current)
                    mapRef.current.fitBounds(editableLayers.current.getBounds()); //ACÁ SI...funciona zoom a todos los poligonos

                    editableLayers.current.eachLayer((layer) => {
                        if (layer) {
                            console.log(layer);
                        }
                    })
                })                
            }            
        }
    }, [addLAYER]) 
  

    //NUEVA PRUEBA solo la primera vez
    //**** B */
    useEffect(()=>{
        console.log("cuando carga -- AddLAYER") 
        if(textGEOM !== vacioG){
        
            //alert("ALTER 4 - MAPEAR DESDE PRUEBA #341");        
            let datos = geom; 
            //console.log(datos);

            if(datos.features.length > 0){

                return datos.features.map((feature, index) => {                    
                    var geoJsonLayerA = L.geoJson(null, {style: AAStyle}).addTo(mapRef.current);//poner el estilo acá funciona
                    geoJsonLayerA.on('layeradd', function (e) {
                        var type = e.layerType,
                        layer = e.layer;                        
                        
                        setAddLAYER(addLAYER => [...addLAYER, layer]);//
                    });
                    geoJsonLayerA.addData(feature); //usar feature
                    //mapRef.current.fitBounds(geoJsonLayerA.getBounds()); //FUNCIONA, PERO NO HACER ACÁ
                    geoJsonLayerA.clearLayers();
                })
            }  
            console.log("#389 OSO AA-002");
                       
        }  
    }, []);

    /*BACKUP Useeffect
    useEffect(()=>{
        console.log("cuando carga -- AddLAYER") 
        if(textGEOM !== vacioG){
        
            alert("ALTER 4 - MAPEAR DESDE PRUEBA #341");           

            let datos = geom; 
            console.log(datos);

            let geoJsonLayerB = L.geoJson().addTo(mapRef.current);

            geoJsonLayerB.on('layeradd', function (e) {
                //console.log(e.layer)
                var type = e.layerType,
                layer = e.layer;

                setAddLAYER(addLAYER => [...addLAYER, layer]);
            });

            if(datos.features.length > 0){
                geoJsonLayerB.addData(datos, {style:geojsonTempC});
                geoJsonLayerB.clearLayers();
            }
                       
        }  
    }, []);
    */
       
    //****LLAMAR SOLO CUANDO FALLA EL BOUND***(5-abril-2023)
    //nota: armar una para consultar la circ si falla el limite de la secc (PENDIENTE)
    const getSoloPartido=async()=>{
        let urlB=`https://geo.arba.gov.ar/geoserver/idera/ows?`;
        let parametersB=`service=WFS&version=1.0.0&request=GetFeature&typeName=idera:Departamento&maxFeatures=10&outputFormat=application/json&${cqlFilterPartido}&SRSNAME=EPSG:4326`;
        let urlWFS=`${urlB}${parametersB}`;
        const res= await fetch(urlWFS);
        const data= await res.json(); 
        setCharacterFILTER(data);
    }

    const getData = async ()=>{    
        let urlB=`https://geo.arba.gov.ar/geoserver/idera/ows?`;
        let parametersB=`service=WFS&version=1.0.0&request=GetFeature&${typeName}&maxFeatures=50&outputFormat=application/json&${cqlFilter}&SRSNAME=EPSG:4326`;
        let urlWFS=`${urlB}${parametersB}`;      
        const response= await fetch(urlWFS);
        //console.log(response)
        
        if (response.ok) {
            const res = await response.json()
            .then(res => {
                setCharacterFILTER(res);			
            })
            .catch(err => console.log(err))
            .finally(() => setCharacterFILTER(null));
            //return res
        } else {
            throw new Error('Network response was not ok.')
        }
        
    } 

    /*useEffect(()=>{
        //console.log("DESPUES DE EDITAR------>", layerGeoJSON)
    }, [layerGeoJSON])*/

    /*
    const addPolygon = (jsonL) => {
        //console.log("ACA hacer carga de los features");

        //const len_jsonL = jsonL.length;
        const lastMarker = polygonData[polygonData.length - 1];

        var textoG = JSON.stringify(jsonL);//.geometry
        //console.log(textoG);
        setPolygonData([...polygonData, textoG]);
    }*/  
	   

    useEffect(()=>{
        if(geoJsonRef.current!==null){
            mapRef.current.addLayer(geoJsonRef.current);
        }

    }, [geoJsonRef.current])

	useEffect(() => {
                
        //layer_1101.addTo(mapRef.current); // <---------------------------------
        geoJsonLayer.addTo(mapRef.current);
        //EX 19-09-2026 (unificacion de los mapas): requiredHARD queda comentado. En la edicion se
        //agregaba una capa VACIA que nada llena (todas las referencias estan comentadas), o sea un
        //no-op que ademas obligaba a definir la variable. Ver la nota junto a la definicion.

        editableLayers.current = new L.FeatureGroup();
        editableLayers.current.addTo(mapRef.current);

        editableLayers.current.on('layeradd', function (e) {
            
            var type = e.layerType,
            layer = e.layer;
            console.log(layer);
            //editableLayers.current.addLayer(layer);

            editableLayers.current.addLayer(layer);
            console.log(editableLayers.current);
        });

        mapRef.current.on('draw:deleted', function (e) {
            /*var deletedLayers = e.layers._layers;
            for (var layer in deletedLayers) {
               console.log(deletedLayers[layer]);
            }*/
            let layerGeoJSON = editableLayers.current.toGeoJSON();
            console.log(layerGeoJSON)
        });

        mapRef.current.on('draw:deletestart', function(e) {
            //alert("started");            
            let layerGeoJSON = editableLayers.current.toGeoJSON(); //editableLayers.current.
            console.log(layerGeoJSON);
            savePolygon(layerGeoJSON);
        });

        //draw:deletestop
        mapRef.current.on('draw:deletestop', function (e) {
            //console.log(e);
            //console.log(e.target);
            let layerGeoJSON = editableLayers.current.toGeoJSON(); //editableLayers.current.
            //console.log(layerGeoJSON);
            savePolygon(layerGeoJSON)
        })

        mapRef.current.on('draw:editstart', function (e) {
            //console.log(e);
            //console.log(e.target);
            //console.log("started editing")
        });        
        
        mapRef.current.on('draw:edited', function (e) {
            //console.log(e);
            //console.log(e.target);
            let layerGeoJSON = editableLayers.current.toGeoJSON(); //editableLayers.current.
            //console.log(layerGeoJSON);
            savePolygon(layerGeoJSON)
        })

        mapRef.current.on("draw:drawstart", function (event) {
            //console.log("event here", event);
        });

        mapRef.current.on("draw:drawstop", function (event) {
            //console.log("event here STOP", event);

            let layerGeoJSON = editableLayers.current.toGeoJSON(); // editableLayers.current.
            //console.log("TERMINO DE DIBUJAR----->",layerGeoJSON);
            savePolygon(layerGeoJSON);
            //var type = e.layerType,
            //layer = e.layer;
            //console.log("LAYER--->",layer);
        });

        mapRef.current.on('draw:created', function (e) {
            //console.log('Creando');
            var type = e.layerType,
            layer = e.layer;
            //console.log(layer);
        
            var featureId = L.stamp(layer);
            layer.feature = {
                'type': 'Feature',
                'properties': {                    
                    'feature_type': e.layerType
                }
            };
            ////'_leaflet_id': featureId,
        
            var jsonL = layer.toGeoJSON();
            //console.log(jsonL);

            //https://javascript.plainenglish.io/how-to-add-to-an-array-in-react-state-3d08ddb2e1dc
            //NO USAR
            //setNewParcel(newParcel => [...newParcel, jsonL]); // <---- FUNCION CONTENEDORA (wrapper function)

            /*let layerGeoJSON = editableLayers.current.toGeoJSON();
            //console.log(layerGeoJSON);
            savePolygon(layerGeoJSON);*/
            
        });


        /*mapRef.current.on(L.Draw.Event.DELETESTART, function(e) {
            console.log("delete start");
        });
        mapRef.current.on(L.Draw.Event.DELETESTOP, function(e) {
            console.log("delete stop");
        });
        mapRef.current.on(L.Draw.Event.DELETED, function(e) {
            var layers = e.layers;
            console.log("LAYERS--->", layers);
            layers.eachLayer(function(layer) {
              var featureId = L.stamp(layer);
              if (!layer.feature) {
                layer.feature = {
                  'type': 'Feature'
                };
              }
              if (!layer.feature.properties) {
                layer.feature.properties = {};
              }
              layer.feature.properties._leaflet_id = featureId;
              layer.feature.properties.layerId = layer.options.layerId;
              if (typeof layer.getRadius === 'function') {
                layer.feature.properties.radius = layer.getRadius();
              }
            });
            
            console.log("deleted shapes: " + JSON.stringify(layers.toGeoJSON()));
          
          });*/

        mapRef.current.on(L.Draw.Event.CREATED, function(e) {
            var type = e.layerType,
              layer = e.layer;
              console.log(layer);
            if (type === "marker") {
              layer.bindPopup("A popup!");
            }
            console.log("AQUI event CREATED---->",layer );
            
            //mapRef.current.addLayer(editableLayers.current);

            //EX 19-09-2026: mismo estilo unificado que los poligonos cargados (antes gardenStyle, opaco).
            editableLayers.current.addLayer(layer, {style: estiloPoligonoEditable}); // editableLayers.current.

            //NOTA: lo agrega con el ESTILO, pero no deja editar!!
            /*
            var jsonL = layer.toGeoJSON();
            //console.log(jsonL);
            editableLayers.current = L.geoJSON(jsonL, {style: geojsonTemp}).addTo(mapRef.current);
            */
                      
        });

        
        //*****NOTA: Revisar con el código sin comentar error. Comentando sigue editando*****
        mapRef.current.on(L.Draw.Event.EDITED, function(e) {
            //e.layers.eachLayer(layer => //console.log('got a layer!', layer));
            console.log("EVENT EDIT - tira el error")
            var type = e.layerType,
            layer = e.layer;
            //if(layer !== null){
                //editableLayers.current.addLayer(layer);
            //}            
        });           

        const baseMaps = {
            "<span style='color: gray'>Sin capa base</span>": sin_base,
            "<span style='color: gray'>OpenStreetMap</span>": osm,
            "<span style='color: gray'>ArgenMap</span>": argenMap,
            //EX 16-10-2026: se saca la capa base "Carto" (CartoDB_DarkMatter): el servicio
            //ahora pide una API Key y la capa no carga. Reportado por el usuario.
            //"<span style='color: gray'>Bing</span>": bingLayer,
            "<span style='color: gray'>Google Satelital</span>": gMapsSat            
        };        

        const overlayMaps = {
            "Polygon": editableLayers.current,
            //"ARBA_prueba": layer_ARBA,
            "ARBA": layer_1101,
            //EX 19-09-2026: se saca "ARBA base" (layer_4101). Apunta a
            //http://181.171.117.68/geoserver/wms? y ese servidor NO RESPONDE (probado: HTTP 000, ni por HTTP
            //ni por HTTPS). Y aunque respondiera, en una pagina HTTPS el navegador bloquearia el pedido por
            //contenido mixto. O sea que no puede dibujar nada ni en local ni en produccion: era una entrada
            //del control de capas que no mostraba nada. Si algun dia hace falta una carta base de ARBA, hay
            //que buscar un endpoint con HTTPS (los servidores geo.arba.gov.ar y carto.arba.gov.ar si
            //responden).
            //"ARBA base": layer_4101,
            "Zonificación según usos": layer_2101,
            "Areas - Ley 8912/77" : layer_3101,
            //"Query": geoJsonRef,
            //"Prueba": requiredHARD,
            //"Temp": tempLayer  -----> NO se agrega la capa con la que se hizo la busqueda          
        };
        L.control.layers(baseMaps, overlayMaps, {position: 'topleft'}).addTo(mapRef.current);

        const options = {
            position: "topleft",
            draw: {
                polyline: false,
                polygon: {
                    title: 'Dibujar nuevo poligono',
                    icon: new L.DivIcon({
                        iconSize: new L.Point(10, 10),
                        className: 'leaflet-div-icon leaflet-editing-icon'
                    }),
                    //EX 19-09-2026: el poligono en curso de dibujo usa el MISMO estilo que los cargados y
                    //que los ya dibujados (ESTILO_POLIGONO), asi se ve igual durante todo el proceso.
                    shapeOptions: Object.assign({ clickable: true }, ESTILO_POLIGONO),
                    allowIntersection: false, // Restricts shapes to simple polygons 
                    drawError: {
                        color: '#e1e100', // Color the shape will turn when intersects 
                        message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect 
                    }
                },
                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false
            },
            edit: {
                featureGroup: editableLayers.current //REQUIRED!! //editableLayers.current.                
            },
        };
          
        const drawControl = new L.Control.Draw(options);

        drawControl.addTo(mapRef.current);

	}, [])

	return (
        <div 
            id='map_nuevo' //EX 19-09-2026: tiene que coincidir con L.map('map_nuevo')
            style={style}>
            {/*<InputBusqueda />*/}
            
        </div>
    )
    
}

export default Map_Expedientes;